var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$auth.ready())?_c('div',[_c('router-view')],1):_vm._e(),_vm._v(" "),(!_vm.$auth.ready())?_c('div',{staticClass:"splash"},[_vm._m(0)]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container  d-flex h-100"},[_c('div',{staticClass:"row justify-content-center text-primary w-100 align-self-center text-white"},[_c('i',{staticClass:"fa fa-spin fa-spinner"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-921744a4","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 624
// module chunks = 1